import React from "react";
import SEO from "@/components/site/SEO";

const NOTES = [
  "Pricing may vary based on property size, location, add-ons, and complexity.",
  "Listing Essential is paid in full at booking.",
  "Listing Standard and Listing Plus require 50% due at booking and 50% due before final asset delivery or go-live support.",
  "Monthly plans are paid at the start of each billing period.",
  "No final assets are released until the required payment has been received.",
  "Included monthly visits do not roll over unless approved in writing.",
  "Larger or complex properties may require custom quotes.",
  "Travel fees may apply outside core areas.",
  "LotWise Home does not guarantee sale price, speed of sale, inquiries, showings, offers, or MLS placement.",
  "MLS access and publishing remain subject to agent, brokerage, board, and platform rules.",
  "Add-ons are subject to availability, property type, timing, and location.",
];

export default function Terms() {
  return (
    <div className="bg-white text-brand-black">
      <SEO
        title="Terms · Service Notes"
        description="LotWise Home service notes — pricing, payment terms, add-ons, MLS language, deliverables, travel, revisions, and service boundaries."
        path="/terms"
      />
      <section className="bg-brand-black text-white">
        <div className="mx-auto max-w-[900px] px-5 md:px-10 py-20 md:py-24">
          <div className="eyebrow text-white/60">Legal</div>
          <h1 className="mt-4 text-[36px] md:text-5xl font-bold tracking-tight">Terms · Service Notes</h1>
        </div>
      </section>
      <section className="bg-white">
        <div className="mx-auto max-w-[820px] px-5 md:px-10 py-16 md:py-24">
          <p className="text-[15.5px] leading-relaxed text-brand-gray mb-8">
            These service notes explain how LotWise Home works commercially. They are written in
            plain English on purpose. If anything is unclear for your specific situation, contact us
            at <a href="mailto:hello@lotwiseauto.ca" className="text-brand-black link-underline">hello@lotwiseauto.ca</a> before booking.
          </p>
          <ul className="divide-y divide-brand-gray/20 border-y border-brand-gray/20">
            {NOTES.map((n, i) => (
              <li key={i} className="py-5 flex items-start gap-4">
                <span className="text-[11px] tracking-[0.2em] uppercase text-brand-gray mt-1 w-10 shrink-0 tabular-nums">{String(i + 1).padStart(2, "0")}</span>
                <span className="text-[15px] leading-relaxed text-brand-black">{n}</span>
              </li>
            ))}
          </ul>
        </div>
      </section>
    </div>
  );
}
